import type {RouteLocationNormalizedGeneric} from 'vue-router';
import {START_LOCATION} from 'vue-router';
import {useShipmentLabel} from '@/composables/useShipmentLabel/useShipmentLabel';

/**
 * Resumes a pending label download when the user re-enters the app after returning from the
 * payment provider.
 *
 * Fires only on the initial navigation of a fresh page load (`from === START_LOCATION`) — the
 * re-entry — so it is page-agnostic and never runs on in-session navigations. That gating matters:
 * the create/edit flows `router.push` to orders-overview right after the payment redirect, and
 * `window.location.assign`'s unload is deferred; running the resume on that in-session navigation
 * would consume `afterPayment` before the page ever unloads, losing it before the user returns.
 *
 * Fire-and-forget: it never blocks or alters navigation. `continueWithLabelDownload` is a no-op
 * when there is no pending `afterPayment`.
 */
export const resumeDownloadGuard = (_to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) => {
  if (from === START_LOCATION) {
    void useShipmentLabel().continueWithLabelDownload();
  }

  return true;
};
